/*
This function adds the metering headers to the request header object
*/
export const addMeteringHeaders = ({ anonymousId, treatmentState }) => {
  if (!anonymousId || !treatmentState) return null;
  // If treatment is OFF then no need to send the AnonymousId header
  if (treatmentState === 'off') {
    return null;
  }
  return {
    'X-Auth-AnonymousId': anonymousId,
  };
};

/*
This function is specific for kbyg api calls. This function filters the meter property from arguments and return it back.
The KBYG api calls uses a common baseFetchGraphForecast function that accepts variable number of arguments.
So it is difficult to parse out the meter property from the arguments since the number of arguments keeps on changing for different actions.
This function accepts a ...rest argument which would contain the meter property.
*/
export const findMeterFromArguments = (args) =>
  args.find((elem) => {
    const meterProperty = elem?.meter;
    return !!meterProperty;
  });

/*
This function accepts a meter object and filters the meterRemaining property from it.
Also it computes the meterHeaders that should be used in the api call.
*/
export const getMeterParamsForRequest = (meter) => {
  const meterHeaders = meter ? addMeteringHeaders(meter) : null;
  const meterRemaining = meter?.meterRemaining;
  return { meterHeaders, meterRemaining };
};

export default addMeteringHeaders;
